import { render, staticRenderFns } from "./InsFullCalendar.vue?vue&type=template&id=2856458a&"
import script from "./InsFullCalendar.vue?vue&type=script&lang=ts&"
export * from "./InsFullCalendar.vue?vue&type=script&lang=ts&"
import style0 from "./InsFullCalendar.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports